import axios from "axios";
export const state = {
    accounts: [],
    transactions: [],
    transaction_details: [],
    income_statement: [],
    balance_sheet: [],
    account_save_status: false,
    filter_status: false,
    revenue_details: [],
    costofsales_details: [],
    expense_details: [],
    otherincome_details:[]
};
export const getters = {
    Accounts: state => state.accounts.data,
    Transactions: state => state.transactions,
    TransactionDetails: state => state.transaction_details.data,
    AccountSaveStatus: state => state.account_save_status,
    IncomeStatement: state => state.income_statement,
    BalanceSheet: state => state.balance_sheet,
    filterStatus: state => state.filter_status,
    RevenueDetails: state => state.revenue_details,
    CostofsalesDetails: state => state.costofsales_details,
    ExpenseDetails: state => state.expense_details,
    OtherincomeDetails: state => state.otherincome_details,
 
};

export const mutations = {
    SET_ACCOUNTS(state, newValue) {
        state.accounts = newValue
    },
    SET_TRANSACTIONS(state, newValue) {
        state.transactions = newValue
    },
    SET_ACCOUNTSAVE_STATUS(state, newValue) {
        state.account_save_status = newValue
    },
    SET_TRANSACTIONDETAILS(state, newValue) {
        state.transaction_details = newValue
    },
    SET_INCOMESTATEMENT(state, newValue) {
        state.income_statement = newValue
    },
    SET_BALANCESHEET(state, newValue) {
        state.balance_sheet = newValue
    },
    SET_FILTERSTATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_REVENUEDETAILS(state, newValue) {
        state.revenue_details = newValue
    },
    SET_COSTOFSALES_DETAILS(state, newValue) {
        state.costofsales_details = newValue
    },
    SET_EXPENSEDETAILS(state, newValue) {
        state.expense_details = newValue
    },
    SET_OTHERINCOME_DETAILS(state, newValue) {
        state.otherincome_details = newValue
    },
   
};

export const actions = {
    fetchAccounts({ commit }) {
        axios.get('coa').then(e_res => {
            commit('SET_ACCOUNTS', e_res.data)
        })
    },

    fetchTransactions({ commit }) {
        axios.get('coatransactions').then(e_res => {
            commit('SET_TRANSACTIONS', e_res.data)
        })
    },

    fetchTrialBalance({ commit }, payload) {
        commit('SET_FILTERSTATUS', true)
        axios.post('trialbalance', payload).then(e_res => {
            commit('SET_TRANSACTIONS', e_res.data)
            commit('SET_FILTERSTATUS', false)
        })
    },

    fetchTransactionDetails({ commit }, id) {
        axios.get(`fetch_coatransactions/${id}`).then(e_res => {
            commit('SET_TRANSACTIONDETAILS', e_res.data)
        })
    },
    fetchIncomestatement({ commit }, payload) {
        commit('SET_FILTERSTATUS', true)
        axios.post('income_statement', payload).then(e_res => {
            commit('SET_INCOMESTATEMENT', e_res.data)
            commit('SET_FILTERSTATUS', false)
        })
    },
    fetchBalancesheet({ commit }, payload) {
        commit('SET_FILTERSTATUS', true)
        axios.post('balance_sheet', payload).then(e_res => {
            commit('SET_BALANCESHEET', e_res.data)
            commit('SET_FILTERSTATUS', false)
        })
    },

    SaveAccount({ commit,dispatch },payload) {
        // console.log(payload);
        commit('SET_ACCOUNTSAVE_STATUS', true);
        axios.post('coa',payload).then(() => {
            dispatch('fetchAccounts');
            let message = { 'msg': "New Account added successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_ACCOUNTSAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_ACCOUNTSAVE_STATUS', false)
            let message = { 'msg': "Error Adding Account" }
            dispatch('notification/error', message, { root: true })
        })
    },

    SaveTransaction({ commit,dispatch },payload) {
        // console.log(payload);
        commit('SET_ACCOUNTSAVE_STATUS', true);
        axios.post('coatransactions',payload).then(() => {
            dispatch('fetchTrialBalance', payload.filterData);
            let message = { 'msg': "New Transaction added successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_ACCOUNTSAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_ACCOUNTSAVE_STATUS', false)
            let message = { 'msg': "Error Adding Transaction" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit account
    EditAccount({ commit,dispatch },payload) {
        commit('SET_ACCOUNTSAVE_STATUS', true);
        axios.put(`coa/${payload.id}`, payload).then(() => {
            dispatch('fetchAccounts');
            let message = { 'msg': "Account updated successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_ACCOUNTSAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_ACCOUNTSAVE_STATUS', false)
            let message = { 'msg': "Error updating Account" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete account
    DeleteAccount({ commit,dispatch },payload) {
        commit('SET_ACCOUNTSAVE_STATUS', true);
        axios.delete(`coa/${payload.id}`).then(() => {
            dispatch('fetchAccounts');
            let message = { 'msg': "Account deleted successfully" }
            dispatch('notification/success', message, { root: true })
            commit('SET_ACCOUNTSAVE_STATUS', false); 
        }).catch(() => {
            commit('SET_ACCOUNTSAVE_STATUS', false)
            let message = { 'msg': "Error Deleting Account" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchRevenueDetails({ commit }, payload) {        
        if(payload){
            commit('SET_FILTERSTATUS', true)
            axios.post('revenue_details',payload).then(e_res => {
                commit('SET_REVENUEDETAILS', e_res.data)
                commit('SET_FILTERSTATUS', false)
            })
        }else{
            commit('SET_REVENUEDETAILS', [])
        }
        
    },

    fetchCostofsalesDetails({ commit }, payload) {
        if(payload){
            commit('SET_FILTERSTATUS', true)
            axios.post('costofsales_details',payload).then(e_res => {
                commit('SET_COSTOFSALES_DETAILS', e_res.data)
                commit('SET_FILTERSTATUS', false)
            })
        }else{
            commit('SET_COSTOFSALES_DETAILS', [])
        }
    },

    fetchExpenseDetails({ commit }, payload) {
        if(payload){
            commit('SET_FILTERSTATUS', true)
            axios.post('expense_details',payload).then(e_res => {
                commit('SET_EXPENSEDETAILS', e_res.data)
                commit('SET_FILTERSTATUS', false)
            })
        }else{
            commit('SET_EXPENSEDETAILS', [])
        }

    },

    fetchOtherincomeDetails({ commit }, payload) {
        if(payload){
            commit('SET_FILTERSTATUS', true)
            axios.post('otherincome_details',payload).then(e_res => {
                commit('SET_OTHERINCOME_DETAILS', e_res.data)
                commit('SET_FILTERSTATUS', false)
            })
        }else{
            commit('SET_OTHERINCOME_DETAILS', [])
        }

    },
};